/**
 * Who sold this trip, and how to reach them — on the dispatcher's trip
 * screen only, never on a board row.
 *
 * The office is on a phone, being asked about one trip, and the answer is
 * often "ring Booking.com". So the partner's number and address are LINKS:
 * `telUrl` and `mailUrl`, the portal's own (Utils/contactLinks — the same
 * two the customer card and DriverContact use), so one place knows how to
 * turn a contact into a call or a message.
 *
 * A trip Pickup Hungary sold itself reads DIRECT — a sentence, not three
 * empty fields. A partner whose record has been deactivated since the
 * booking was taken still reads as a partner: the API says `direct: false`
 * with no name, and saying "direct" there would be a lie.
 *
 * A missing number or address renders no control at all, never a link that
 * goes nowhere.
 */
import React from 'react';
import { mailUrl, telUrl } from '../../../Utils/contactLinks';
import { MailIcon, PhoneIcon } from '../Components/Icons';
import { Facts } from '../Components/TripCards';

const DIRECT = 'Pickup Hungary (direct)';
const UNKNOWN_PARTNER = 'A partner we no longer have on file';

/** 'WhiteLabel Travel GmbH' — who to say the trip is for. */
export const partnerName = (partner) => {
  if (!partner || partner.direct) return DIRECT;

  return partner.name || UNKNOWN_PARTNER;
};

export default function PartnerCard({ partner }) {
  const direct = !partner || partner.direct;
  const name = partnerName(partner);
  const phone = direct ? '' : partner.phone_number || '';
  const email = direct ? '' : partner.email || '';

  return (
    <>
      <Facts
        title="Sold by"
        rows={[
          { key: 'Partner', value: name },
          // Shown as text as well as a link: a number is something the
          // office reads out to a colleague as often as it taps.
          { key: 'Phone', value: phone },
          { key: 'Email', value: email },
        ]}
      />
      {phone || email ? (
        <div className="pp-dispatch__contact">
          {phone ? (
            <a
              className="pp-btn pp-btn--sm pp-btn--outline"
              href={telUrl(phone)}
              aria-label={`Call ${name}`}
            >
              <PhoneIcon size={16} />
              Call
            </a>
          ) : null}
          {email ? (
            <a
              className="pp-btn pp-btn--sm pp-btn--outline"
              href={mailUrl(email)}
              aria-label={`Email ${name}`}
            >
              <MailIcon size={16} />
              Email
            </a>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
